module.exports = __webpack_public_path__ + "static/media/Harsh Pande.3d283a98.jpg";